import { z } from 'zod'

/**
 * `LGH-035`. The console's own vocabulary for `RfqSourceInvite` — kept
 * distinct from `contractRfqSourceInviteSchema` even though today's wire
 * shape happens to use the same field names, for the same reason every other
 * console type here is kept distinct from its contract twin: a translation
 * step is what gives this side somewhere to stand if the wire ever changes
 * without the console needing to.
 */
export const rfqSourceRoleSchema = z.enum(['staffAdmin', 'staffStandard', 'externalRfqOnly'])
export type RfqSourceRole = z.infer<typeof rfqSourceRoleSchema>

export const rfqSourceInviteStatusSchema = z.enum(['pending', 'active', 'revoked'])
export type RfqSourceInviteStatus = z.infer<typeof rfqSourceInviteStatusSchema>

export const rfqSourceTargetKindSchema = z.enum(['phone', 'email'])
export type RfqSourceTargetKind = z.infer<typeof rfqSourceTargetKindSchema>

export const rfqSourceInviteSchema = z
  .object({
    id: z.string(),
    tenantId: z.string(),
    target: z.object({ kind: rfqSourceTargetKindSchema, value: z.string() }),
    role: rfqSourceRoleSchema,
    status: rfqSourceInviteStatusSchema,
    invitedByStaffId: z.string(),
    invitedAt: z.string(),
    confirmedAt: z.string().nullable(),
    revokedAt: z.string().nullable(),
    revokedByStaffId: z.string().nullable(),
  })
  .strict()
export type RfqSourceInvite = z.infer<typeof rfqSourceInviteSchema>

export const rfqSourceInviteListSchema = z.array(rfqSourceInviteSchema)

export const createRfqSourceInviteRequestSchema = z.object({
  target: z.object({ kind: rfqSourceTargetKindSchema, value: z.string().min(1) }),
  role: rfqSourceRoleSchema,
})
export type CreateRfqSourceInviteRequest = z.infer<typeof createRfqSourceInviteRequestSchema>

export const confirmRfqSourceInviteRequestSchema = z.object({ otp: z.string().min(1) })
export type ConfirmRfqSourceInviteRequest = z.infer<typeof confirmRfqSourceInviteRequestSchema>
